import React, { useState, useEffect, useContext } from "react";
import "../App.css";
import axios from "axios";
import Sidebar from "../componenteExtra/SidebarAdmin";
import { GrupoContext } from "../GrupoContext";
import Modal from "react-modal";
import SessionManager from "../componenteExtra/SessionManager";
import { Toaster, toast } from "react-hot-toast";

Modal.setAppElement("#root");

const Asistentes = () => {
  const { grupo } = useContext(GrupoContext);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deactivateModalOpen, setDeactivateModalOpen] = useState(false);
  const [selectedAsistente, setSelectedAsistente] = useState(null);
  const [nuevoGrupo, setNuevoGrupo] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [newAsistente, setNewAsistente] = useState({
    numero_grupo: "",
    nombre_asistente: "",
  });

  const token = localStorage.getItem("access_token");

  const fetchStaffList = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/get_all_staff2`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setStaffList(response.data);
      })
      .catch((error) => console.error("Error fetching data: ", error));
  };

  useEffect(() => {
    fetchStaffList();
  }, []);

  const closeModal = () => {
    setModalIsOpen(false);
    setNewAsistente({ numero_grupo: "", nombre_asistente: "" });
  };

  const handleAddAsistente = async () => {
    const { numero_grupo, nombre_asistente } = newAsistente;

    if (!numero_grupo || !nombre_asistente) {
      toast.error("Por favor completa ambos campos.");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/add_asistente`,
        {
          numero_grupo: parseInt(numero_grupo),
          nombre_asistente,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Asistente añadido con éxito!");
      fetchStaffList();
      closeModal();
    } catch (error) {
      console.error("Error al agregar asistente:", error.response?.data || error);
      toast.error("Error al agregar asistente.");
    }
  };

  // Abrir modales
  const openEditModal = (asistente) => {
    setSelectedAsistente(asistente);
    setNuevoGrupo(asistente.numero_grupo);
    setEditModalOpen(true);
  };

  const openDeactivateModal = (asistente) => {
    setSelectedAsistente(asistente);
    setDeactivateModalOpen(true);
  };

  // Enviar modificación
  const handleModificar = async () => {
    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/modificar_asistente`, {
        id_asistente: selectedAsistente.id_asistente,
        nuevo_grupo: parseInt(nuevoGrupo),
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Grupo modificado con éxito");
      fetchStaffList();
      setEditModalOpen(false);
    } catch (err) {
      toast.error("Error al modificar grupo");
    }
  };

  // Confirmar desactivación
  const handleDesactivar = async () => {
    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/desactivar_asistente`, {
        id_asistente: selectedAsistente.id_asistente,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Asistente desactivado");
      fetchStaffList();
      setDeactivateModalOpen(false);
    } catch (err) {
      toast.error("Error al desactivar asistente");
    }
  };

  return (
    <div className="app">
      <SessionManager />
      <Sidebar />
      <div className="main-content">
        <div className="main-panel">
          <h1>Asistentes GET</h1>
          <button className="add-user-btn" onClick={() => setModalIsOpen(true)}>
            ➕ Agregar asistente</button>

          <div className="activities-table-container">
            <table className="activities-table">
              <thead>
                <tr>
                  <th>Estado</th>
                  <th>Número de grupo</th>
                  <th>Nombre asistente</th>
                  <th>Cantidad de actividades asignadas</th>
                  <th>Actividades iniciadas</th>
                  <th>Horas trabajadas</th>
                  <th>Completadas exitosas</th>
                  <th>Completadas con dificultades</th>
                  <th>Sumatoria actividades asignadas</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {staffList.map((staff, index) => {
                  const totalActivities =
                    staff.nro_actividades_sin_complicaciones +
                    staff.nro_actividades_con_complicaciones;
                  return (
                    <tr key={index}>
                      <td>
                        <span className={staff.estado === "activo" ? "estado-activo" : "estado-inactivo"}>
                          {staff.estado}
                        </span>
                      </td>
                      <td>{staff.numero_grupo}</td>
                      <td>{staff.nombre_asistente}</td>
                      <td>{staff.cantidad_actividad_asignadas}</td>
                      <td>{staff.actividades_iniciadas}</td>
                      <td>{staff.horas_get}</td>
                      <td>{staff.nro_actividades_sin_complicaciones}</td>
                      <td>{staff.nro_actividades_con_complicaciones}</td>
                      <td>{staff.sumatoria_actividades_asignadas}</td>
                      <td>
                        <button onClick={() => openEditModal(staff)} className="edit-button">✏️Modificar</button>
                        <button onClick={() => openDeactivateModal(staff)} className="delete-button">🚫Desactivar</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className="modal-content" overlayClassName="modal-overlay">
            <h2>Agregar nuevo asistente</h2>
            <select
              value={newAsistente.numero_grupo}
              onChange={(e) =>
                setNewAsistente({ ...newAsistente, numero_grupo: e.target.value })
              }
            >
              <option value="">Selecciona un grupo</option>
              {[1, 2, 3, 4].map((num) => (
                <option key={num} value={num}>
                  Grupo {num}
                </option>
              ))}
            </select>
            <input
              type="text"
              placeholder="Nombre asistente"
              value={newAsistente.nombre_asistente}
              onChange={(e) =>
                setNewAsistente({ ...newAsistente, nombre_asistente: e.target.value })
              }
            />
            <div className="modal-buttons">
              <button onClick={handleAddAsistente} className="submit-button">Añadir asistente</button>
              <button onClick={closeModal} className="close-button">Cerrar</button>
            </div>
          </Modal>
          <Modal isOpen={editModalOpen} onRequestClose={() => setEditModalOpen(false)} className="modal-content" overlayClassName="modal-overlay">
            <h2>Modificar grupo</h2>
            <select value={nuevoGrupo} onChange={(e) => setNuevoGrupo(e.target.value)}>
              {[1, 2, 3, 4].map((num) => (
                <option key={num} value={num}>Grupo {num}</option>
              ))}
            </select>
            <div className="modal-buttons">
              <button className="submit-button" onClick={handleModificar}>Guardar cambios</button>
              <button className="close-button" onClick={() => setEditModalOpen(false)}>Cancelar</button>
            </div>
          </Modal>

          <Modal isOpen={deactivateModalOpen} onRequestClose={() => setDeactivateModalOpen(false)} className="modal-content" overlayClassName="modal-overlay">
            <h2>¿Deseas desactivar a este asistente?</h2>
            <p><strong>{selectedAsistente?.nombre_asistente}</strong></p>
            <div className="modal-buttons">
              <button className="submit-button" onClick={handleDesactivar}>Sí, desactivar</button>
              <button className="close-button" onClick={() => setDeactivateModalOpen(false)}>Cancelar</button>
            </div>
          </Modal>
          <Toaster />
        </div>
      </div>
    </div>
  );
};

export default Asistentes;
